<div class="main-wrapper">
  <form [formGroup]="form" (ngSubmit)="saveNew()" class="default-form" [ngClass]="{'update-form' : isUpdate}">
    <div class="form-fields">

      <div class="d-flex px-0" >
        @if (isUpdate) {
          <anms-breadcrum-requirement [requirement]="story" (updateDescription)="updateNameStory($event)" [isUpdate]="isUpdate"></anms-breadcrum-requirement>
        }
        @if (!isUpdate) {
          <h2 class="main-heading mt-2 ml-1">{{ formTitle }}</h2>
        }

      </div>
      <div class="form-fields-inner d-flex flex-column flex-lg-row">
        <div class="px-0 form-container-left left-section">
          @if (!isUpdate) {
            <mat-form-field appearance="fill" class="default-full-width">
              <mat-label>{{ 'anms.requirement.enabler.form.name' | translate }}</mat-label>
              <textarea matInput placeholder="{{'anms.userstory.form.name.placeholder' | translate }}"
                formControlName="itemName"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="10" ></textarea>
              <mat-hint>{{'anms.userstory.form.name.placeholder' | translate }}</mat-hint>
              @if (form.get('itemName').invalid) {
                <mat-error>
                  {{ 'anms.userstory.form.name' | translate }}
                  {{ 'anms.examples.form.error1' | translate }}
                </mat-error>
              }
            </mat-form-field>
          }

          @if (isUpdate) {
            <div  class="upload-file-field mb-2">
              <input class="upload-file-input" id="fileUpload" placeholder="upload a file" type="file" formControlName="fileSource"
                (change)="onHandleFile($event)">
              <span class="material-icons selected-file">
                attach_file
              </span>
            </div>
          }

          <mat-form-field appearance="fill" class="default-full-width">
            <mat-label>{{ 'anms.userstory.form.description' | translate }}</mat-label>
            <textarea class="textarea-form" matInput
              placeholder="{{'anms.userstory.form.description.placeholder' | translate }}"
              formControlName="description"  cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10"></textarea>
            <mat-hint>{{'anms.feature.form.description.placeholder' | translate }}</mat-hint>
            @if (form.get('description').invalid) {
              <mat-error>
                {{ 'anms.feature.form.description' | translate }}
                {{ 'anms.examples.form.error1' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="fill" class="default-full-width acceptance-criteria-field">
            <mat-label>{{ 'anms.userstory.form.acceptanceCriteria' | translate }}</mat-label>
            <textarea class="textarea-form" matInput
              placeholder="{{ 'anms.userstory.form.acceptanceCriteria.placeholder' | translate }}"
              formControlName="acceptanceCriteria"
              matInput
              cdkTextareaAutosize
              #autosize1="cdkTextareaAutosize"
              cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10"></textarea>
            <mat-hint>{{ 'anms.enablerstory.form.acceptanceCriteria.hint' | translate }}</mat-hint>
            @if (form.get('acceptanceCriteria').invalid) {
              <mat-error>
                {{ 'anms.feature.form.acceptanceCriteria' | translate }}
                {{ 'anms.examples.form.error1' | translate }}
              </mat-error>
            }
          </mat-form-field>
          @if (filesOfItem!==undefined && filesOfItem.length>0) {
            <div class="attachment-wrapper">
              @for (file of filesOfItem; track file) {
                <anms-attachment-card  class="mt-1 pr-1 mb-2 " [file]="file" (downloadFileEmmiter)="downLoadFile($event)"
                  (deleteFileEmmiter)="deleteFile($event)">
                </anms-attachment-card>
              }
            </div>
          }
          <mat-form-field appearance="fill" class="default-full-width acceptance-criteria-field">
            <mat-label>{{ 'anms.feature.form.notes' | translate }}</mat-label>
            <textarea class="textarea-form" matInput formControlName="notes"></textarea>
            <mat-hint> Notes </mat-hint>
            @if (form.get('notes').invalid) {
              <mat-error>
                {{ 'anms.feature.form.notes' | translate }}
                {{ 'anms.examples.form.error1' | translate }}
              </mat-error>
            }
          </mat-form-field>

        </div>
        <div class="form-container-right right-section px-0">
          <mat-form-field appearance="fill" class="px-0">
            <mat-label>Feature</mat-label>
            <mat-select formControlName="parentId">
              <mat-option value="">
                None
              </mat-option>
              @if (features$ | async; as features) {
                @for (feature of features; track feature) {
                  <mat-option [value]="feature.id">
                    {{feature.description}}
                  </mat-option>
                }
              }
            </mat-select>
          </mat-form-field>

          @if (isUpdate) {
            @if (states$ | async; as states) {
              <mat-form-field appearance="fill" class="px-0">
                <mat-label>State</mat-label>
                <mat-select formControlName="columnId" (selectionChange)="changeState($event)">
                  @for (state of states; track state) {
                    <mat-option [value]="state.id">
                      {{state.name}}
                    </mat-option>
                  }
                </mat-select>
                <mat-hint>State</mat-hint>
              </mat-form-field>
            }
          }

          <mat-form-field appearance="fill" class="px-0">
            <mat-label>Team</mat-label>
            <mat-select formControlName="teamId">
              @if (teams$ | async; as teams) {
                @for (team of teams; track team) {
                  <mat-option [value]="team.id">
                    {{team.name}}
                  </mat-option>
                }
              }
            </mat-select>
            @if (team.invalid) {
              <mat-error>
                {{ 'anms.form.placeholder.team' | translate }}
                {{ 'anms.examples.form.error1' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="fill" class="px-0">
            <mat-label>Type of Enabler</mat-label>
            <mat-select formControlName="enablerType">
              @for (type of types; track type) {
                <mat-option [value]="type.value">
                  {{type.viewValue}}
                </mat-option>
              }
            </mat-select>
            @if (form.get('enablerType').invalid) {
              <mat-error>
                {{ 'anms.solution.feature.form.enablerType' | translate }}
                {{ 'anms.examples.form.error1' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="fill" class="px-0">
            <mat-label>{{ 'anms.userstory.form.storypoints' | translate }}</mat-label>
            <input matInput placeholder="{{'anms.solution.userstory.form.points.placeholder' | translate }}"
              formControlName="storyPoints">
            <mat-hint>{{'anms.userstory.form.storypoints.placeholder' | translate }}</mat-hint>
            @if (form.get('storyPoints').invalid) {
              <mat-error>
                {{ 'anms.solution.userstory.form.points' | translate }}
                {{ 'anms.examples.form.error1' | translate }}
              </mat-error>
            }
          </mat-form-field>

          @if (isUpdate) {
            <div  class="item-meta">
              <p>Created: <span>{{created | date}}</span></p>
              <p>Last update:<span>{{ updated | date}}</span></p>
            </div>
          }


          @if (isUpdate) {
            <div class="item-meta item-meta-bottom">
              @if (auditHistoryChanges$ |async; as auditHistoryChanges) {
                <mat-expansion-panel hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Show History
                    </mat-panel-title>
                    <!-- <mat-panel-description>
                    This is a summary of the content
                  </mat-panel-description> -->
                </mat-expansion-panel-header>
                @for (history of auditHistoryChanges; track history) {
                  <anms-audit [historyAudit]="history"></anms-audit>
                }
              </mat-expansion-panel>
            }
          </div>
        }

      </div>
    </div>
  </div>
  <div class="form-actions">
    <div class="action-col secondary">
      @if (isUpdate) {
        <button mat-flat-button class="btn-delete" (click)="delete()" type="button"><span
        class="material-icons">delete</span>Delete</button>
      }
    </div>
    <div class="action-col primary">
      @if (isUpdate) {
        <button mat-raised-button color="primary" type="button" (click)="save()" id="save"
          class="btn-save"><span class="material-icons">check</span>Save</button>
        }

        @if (!isUpdate) {
          <button mat-raised-button color="primary" type="submit" id="saveNew" class="btn-save"><span
          class="material-icons">check</span>Save New</button>
        }
      </div>
    </div>
  </form>
</div>
